import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { NeCloudFileSvg } from './NeCloudFileSvg'

export const NeCloudFileIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={NeCloudFileSvg} {...props} />
}
